/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Spaces_Codeviewer_Loading_FileInputs */



/**
* | output |
* | --- |
* | "Loading file..." |
*
* @param {Spaces_Codeviewer_Loading_FileInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const spaces_codeviewer_loading_file = /** @type {((inputs?: Spaces_Codeviewer_Loading_FileInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Spaces_Codeviewer_Loading_FileInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Datei wird geladen...")
	return /** @type {LocalizedString} */ ("Loading file...")
});